import type { GrammarExercise } from "./grammar.js";
import { TENSES_EXERCISES } from "./grammar-exercises-tenses.js";
import { VERB_EXERCISES } from "./grammar-exercises-verbs.js";
import { MISC_EXERCISES } from "./grammar-exercises-misc.js";

export const GRAMMAR_EXERCISES: Record<string, GrammarExercise[]> = {
  ...TENSES_EXERCISES,
  ...VERB_EXERCISES,
  ...MISC_EXERCISES,
};
